import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import uuidv4 from 'uuid/v4';

export const postInteraction = async (
  projectId,
  targetId,
  content,
  contentType,
  targetType
) => {
  const apiPath = `interactions/${projectId}/post-interaction/${contentType}`;

  const body = {
    uuid: uuidv4(),
    targetId: targetId,
    content: content,
    targetType: targetType,
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);
  return response.data;
};
